import { Stack, Typography, Paper, Grid } from "@mui/material";
import _ from "lodash";
import { Phone, Address, Signature, Email } from "../utils/user/form";
import { useAuth } from "../../auth/context";
import Legend from "./Legend";

const Fields = ({ form, canvasDrawRef, ...props }) => {
  const { user } = useAuth();
  const { profile } = user;
  const healthCenter = profile.healthCenter;

  const styleLabel = {
    color: "#606060",
    fontSize: 14,
    fontFamily: `"Inter", sans-serif`,
    fontWeight: 500,
    mb: 1,
  };

  return (
    <Paper
      variant="outlined"
      width="100%"
      sx={{
        p: { xs: "10px", sm: "20px" },
        borderRadius: 3,
        mb: 7,
      }}
    >
      <Grid container spacing={2.5}>
        <Grid item xs={12}>
          <Typography variant="title" sx={{ fontSize: { xs: 20, sm: 24 } }}>
            Editar cuenta
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography sx={styleLabel}>Leyenda</Typography>
          <Legend form={form} />
        </Grid>
        {_.isEmpty(healthCenter) && (
          <>
            <Grid item xs={12}>
              <Typography sx={styleLabel}>Email</Typography>
              <Email form={form} bgColor={true}/>
            </Grid>
            <Grid item xs={12}>
              <Typography sx={styleLabel}>Teléfono</Typography>
              <Phone form={form} name="phone" bgColor={true} />
            </Grid>
            <Grid item xs={12}>
              <Typography sx={styleLabel}>Dirección</Typography>
              <Address form={form} bgColor={true} />
            </Grid>
          </>
        )}
        <Grid item xs={12}>
          <Typography sx={styleLabel}>Firma</Typography>
          <Grid
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Signature form={form} isLoading={props.signatureLoading} bgColor={true}/>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default Fields;
